import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import set from 'lodash/set'
import get from 'lodash/get'
import find from 'lodash/find'
import moment from '../../lib/moment.js'
import axios from 'axios'
import { Container, TabContent, TabPane } from 'reactstrap'
import {
  modalAction,
  authAction,
  leaveRequestAction,
  leaveTypeAction,
  publicHolidayAction,
  leaveGenerationAction,
  compensateRequestAction,
} from './../../actions/'
import {
  authSelector,
  modalSelector,
  leaveRequestSelector,
  leaveTypeSelector,
  publicHolidaySelector,
  leaveGenerationSelector,
  compensateRequestSelector,
} from './../../selectors'
import { BASE_URL } from '../../constants'
import Searchbar from '../../components/my-leave/search-bar'
import withLayout from '../../helpers/withLayout'
import {
  LeaveRequestForm,
  LeaveRequestPreview,
  CompensateRequestForm,
  CompensateRequestPreview,
  DiscardRequest,
} from '../../components/my-leave/form'
import { ModalMessage } from '../../components/my-leave/modal'
import { Dashboard } from '../my-leave/dashboard'
import { Calendar } from '../my-leave/calendar'
import { LeaveHistory } from '../my-leave/leave-history'
import { generateButton } from '../../components/my-leave/helpers/button'
import * as myLeaveHelper from '../../components/my-leave/helpers/my-leave'

class MyLeavePage extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'getMyLeaveRequests')) {
      const myLeave = get(nextProps, 'getMyLeaveRequests')
      set(tempState, 'myLeaveRequests', get(myLeave, 'myLeaveRequests'))
      set(tempState, 'users', get(myLeave, 'users'))
      set(tempState, 'myUser', get(myLeave, 'myUser'))
      set(tempState, 'approverList',
        myLeaveHelper.createApproverList(get(myLeave, 'approverUsers'), get(myLeave, 'myUser.line_manager_id'))
      )
      nextProps.resetGetLeaveRequest()
    }
    if (get(nextProps, 'getMyCompensateRequests.compensateWithMeta')) {
      const myCompensate = get(nextProps, 'getMyCompensateRequests')
      set(tempState, 'myCompensateRequests', get(myCompensate, 'compensateWithMeta'))
      set(tempState, 'myCompensateRequestsHistory', get(myCompensate, 'compensateWithMeta.compensateHistory'))
      set(tempState, 'projectList', myLeaveHelper.createProjectList(get(myCompensate, 'compensateWithMeta.prettyProjects')))
      nextProps.resetGetCompensateRequest()
    }
    if (get(nextProps, 'getPreviewLeaveRequest.meta')) {
      const previewLeave = get(nextProps, 'getPreviewLeaveRequest')
      if (get(previewLeave, 'status') === 200) {
        set(tempState, 'meta', get(previewLeave, 'meta'))
        set(tempState, 'showPreview', !prevState.showPreview)
      } else {
        nextProps.showConfirm('showPreview', get(previewLeave, 'status'), get(previewLeave, 'message'))
      }
      nextProps.resetPreviewLeaveRequest()
    }
    if (get(nextProps, 'getPreviewCompensateRequest.createdCompensatePreview')) {
      const previewCompensate = get(nextProps, 'getPreviewCompensateRequest')
      if (get(previewCompensate, 'status') === 200) {
        set(tempState, 'createdCompensatePreview', get(previewCompensate, 'createdCompensatePreview'))
        set(tempState, 'showCompensatePreview', !prevState.showCompensatePreview)
      } else {
        nextProps.showConfirm('showPreview', get(previewCompensate, 'status'), get(previewCompensate, 'message'))
      }
      nextProps.resetPreviewCompensateRequest()
    }
    if (get(nextProps, 'createLeaveRequestData.createdLeaveRequest')) {
      const createdLeave = get(nextProps, 'createLeaveRequestData')
      const access_token = localStorage.getItem('access_token')
      const user_id = localStorage.getItem('_id')
      nextProps.showConfirm('showSuccess', get(createdLeave, 'status'), get(createdLeave, 'message'))
      nextProps.resetCreateLeaveRequest()
      nextProps.getLeaveRequest(access_token)
      nextProps.getLeaveGeneration(user_id, access_token)
    }
    if (get(nextProps, 'createCompensateRequestData.createdCompensate')) {
      const createdCompensate = get(nextProps, 'createCompensateRequestData')
      const access_token = localStorage.getItem('access_token')
      nextProps.showConfirm('showSuccess', get(createdCompensate, 'status'), get(createdCompensate, 'message'))
      nextProps.resetCreateCompensateRequest()
      nextProps.getCompensateRequest(access_token)
    }
    if (get(nextProps, 'getLeaveGenerationData')) {
      const leaveGeneration = get(nextProps, 'getLeaveGenerationData')
      set(tempState, 'prettyLeaveGeneration', get(leaveGeneration, 'prettyLeaveGeneration'))
      set(tempState, 'prettyLeaveTypeWithLeaveRequest', get(leaveGeneration, 'prettyLeaveTypeWithLeaveRequest'))
      nextProps.resetGetLeavegeneration()
    }
    if (get(nextProps, 'cancelLeaveRequestData.updatedLeaveRequest')) {
      const cancelLeave = get(nextProps, 'cancelLeaveRequestData')
      const access_token = localStorage.getItem('access_token')
      const user_id = localStorage.getItem('_id')
      nextProps.showConfirm('cancelSuccess', get(cancelLeave, 'status'), get(cancelLeave, 'message'))
      nextProps.getLeaveRequest(access_token)
      nextProps.getLeaveGeneration(user_id, access_token)
      nextProps.resetCancelLeaveRequest()
    }
    return tempState
  }

  constructor(props) {
    super(props)
    this.state = {
      activeTab: '1',
      newLeaveRequest: {
        leave_time: 'FULLDAY',
      },
      newCompensateRequest: {
        compensate_time: 'FULLDAY',
      },
      confirmDiscard: false,
      showPreview: false,
      showRequestForm: false,
      filename: '',
      attachment_url: '',

      showCompensateForm: false,
      showCompensatePreview: false,
      projectList: [],
      compensateApprovers: [],

      loading: false,
      myLeaveRequests: [],
      myCompensateRequests: [],
      myCompensateRequestsHistory: [],
      moment: moment(),
      range: 'month',
      approverList: [],
      myUser: null,
      users: null,
      events: [],

      prettyLeaveGeneration: [],
      prettyLeaveTypeWithLeaveRequest: [],
    }
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    const user_id = localStorage.getItem('_id')
    this.props.getAuth(access_token)
    this.props.getLeaveType(access_token)
    this.props.getLeaveRequest(access_token)
    this.props.getCompensateRequest(access_token)
    this.props.getPublicHoliday(access_token)
    this.props.getLeaveGeneration(user_id, access_token)
  }

  onMomentChange = (_moment) => {
    this.setState({ moment: _moment })
  }

  onRangeChange = (range) => {
    this.setState({ range })
  }

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab })
    }
  }

  uploadFile = async (e) => {
    if (e.target.files.length === 0) return
    this.setState({ loading: true })
    const file = e.target.files[0]
    const name = e.target.files[0].name
    const data = new FormData()
    data.set('file', file)
    let attachment_url = ''
    let filename = ''

    try {
      const resp = await axios({
        method: 'post',
        url: `${BASE_URL}/upload/attachment`,
        headers: {
          'authorization': `bearer ${localStorage.getItem('access_token')}`,
        },
        data,
      })
      if (resp.status === 200) {
        attachment_url = resp.data.fileResult.Location
        filename = name
      }
    } catch (error) {
      // const res = error.response.data
      this.props.showConfirm('uploadFail', 'Error', 'The file you uploaded exceeds 5 MB.')
    } finally {
      this.setState({
        loading: false,
        attachment_url,
        filename,
      })
    }
  }

  handleLeaveRequest = () => {
    this.setState({
      attachment_url: '',
      filename: '',
      newLeaveRequest: { leave_time: 'FULLDAY' },
      showRequestForm: !this.state.showRequestForm,
    })
  }

  handleCompensateRequest = () => {
    this.setState({
      newCompensateRequest: { compensate_time: 'FULLDAY' },
      showCompensateForm: !this.state.showCompensateForm,
    })
  }

  handleInputLeave = (type, data) => {
    const { newLeaveRequest } = this.state
    switch (type) {
      case 'leave_type': {
        newLeaveRequest.leave_type_id = data
        this.setState({ newLeaveRequest })
        break
      }
      case 'leave_start_date': {
        newLeaveRequest.start_date = data
        this.setState({ newLeaveRequest })
        break
      }
      case 'leave_end_date': {
        newLeaveRequest.end_date = data
        this.setState({ newLeaveRequest })
        break
      }
      case 'leave_time': {
        newLeaveRequest.leave_time = data.target.value
        this.setState({ newLeaveRequest })
        break
      }
      case 'approver': {
        newLeaveRequest.approver_id = data
        this.setState({ newLeaveRequest })
        break
      }
      case 'remark': {
        newLeaveRequest.remark = data.target.value
        this.setState({ newLeaveRequest })
        break
      }
      default: break
    }
  }

  validateLeaveRequest = () => {
    const newLeaveRequest = { ...this.state.newLeaveRequest }
    if (get(newLeaveRequest, 'leave_type_id.leave_type_id') === undefined
    || get(newLeaveRequest, 'start_date') === undefined
    || get(newLeaveRequest, 'end_date') === undefined
    || get(newLeaveRequest, 'approver_id.approver_id') === undefined) return
    const access_token = localStorage.getItem('access_token')
    newLeaveRequest.attachment_url = this.state.attachment_url
    newLeaveRequest.leave_type_id = newLeaveRequest.leave_type_id.leave_type_id
    newLeaveRequest.approver_id = newLeaveRequest.approver_id.approver_id
    this.setState({ showRequestForm: !this.state.showRequestForm })
    this.props.previewLeaveRequest(newLeaveRequest, access_token)
  }

  clickConfirmLeave = () => {
    const access_token = localStorage.getItem('access_token')
    const { newLeaveRequest } = this.state
    newLeaveRequest.leave_type_id = newLeaveRequest.leave_type_id.leave_type_id
    newLeaveRequest.start_date = moment(newLeaveRequest.start_date).format('YYYY-MM-DD')
    newLeaveRequest.end_date = moment(newLeaveRequest.end_date).format('YYYY-MM-DD')
    newLeaveRequest.approver_id = newLeaveRequest.approver_id.approver_id
    newLeaveRequest.attachment_url = this.state.attachment_url
    this.props.createLeaveRequest(newLeaveRequest, access_token)
    this.setState({ showPreview: !this.state.showPreview })
  }

  handleInputCompensate = (type, data) => {
    const { newCompensateRequest } = this.state
    switch (type) {
      case 'project': {
        const selectedProject = find(this.state.myCompensateRequests.prettyProjects, {
          project_id: data.project_id,
        })
        if (selectedProject) {
          const approvers = myLeaveHelper.createCompensateApproverList(
            get(selectedProject, 'project_compensate_approvers', [])
          )
          newCompensateRequest.project_id = data
          newCompensateRequest.approver_id = approvers[0]
          this.setState({
            newCompensateRequest,
            compensateApprovers: approvers,
          })
        }
        break
      }
      case 'approver': {
        newCompensateRequest.approver_id = data
        this.setState({ newCompensateRequest })
        break
      }
      case 'start_date': {
        newCompensateRequest.start_date = data
        this.setState({ newCompensateRequest })
        break
      }
      case 'end_date': {
        newCompensateRequest.end_date = data
        this.setState({ newCompensateRequest })
        break
      }
      case 'compensate_time': {
        newCompensateRequest.compensate_time = data.target.value
        this.setState({ newCompensateRequest })
        break
      }
      case 'remark': {
        newCompensateRequest.remark = data.target.value
        this.setState({ newCompensateRequest })
        break
      }
      default: break
    }
  }

  validateCompensateRequest = () => {
    const newCompensateRequest = { ...this.state.newCompensateRequest }
    if (get(newCompensateRequest, 'project_id.project_id') === undefined
    || get(newCompensateRequest, 'start_date') === undefined
    || get(newCompensateRequest, 'end_date') === undefined
    || get(newCompensateRequest, 'approver_id.approver_id') === undefined) return
    const access_token = localStorage.getItem('access_token')
    newCompensateRequest.project_id = newCompensateRequest.project_id.project_id
    newCompensateRequest.approver_id = newCompensateRequest.approver_id.approver_id
    this.setState({ showCompensateForm: !this.state.showCompensateForm })
    this.props.previewCompensateRequest(newCompensateRequest, access_token)
  }

  clickConfirmCompensate = () => {
    const access_token = localStorage.getItem('access_token')
    const newCompensateRequest = { ...this.state.newCompensateRequest }
    newCompensateRequest.project_id = newCompensateRequest.project_id.project_id
    newCompensateRequest.approver_id = newCompensateRequest.approver_id.approver_id
    this.props.createCompensateRequest(newCompensateRequest, access_token)
    this.setState({ showCompensatePreview: !this.state.showCompensatePreview })
  }

  selectButton = (confirmStatus, confirmType) => {
    if (confirmStatus === 200) return generateButton('success', () => this.props.hideConfirm(confirmType))
    else if (confirmStatus === 'Error') return generateButton('error', () => this.props.hideConfirm(confirmType))
    return null
  }

  removeFile = () => {
    this.setState({
      attachment_url: null,
      filename: '',
    })
  }

  render() {
    const leaveTypes = get(this.props, 'getLeaveTypeData')
    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
      || get(this.props, 'redirectLeaveRequest.isAuthenticated')
      || get(this.props, 'redirectCompensateRequest.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
      || get(this.props, 'redirectLeaveRequest.redirect')
      || get(this.props, 'redirectCompensateRequest.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }
    const isFetching = get(this.props, 'getIsFetchingLeave')
    || get(this.props, 'getIsFetchingCompensate')
    || get(this.props, 'getIsFetchingLeaveGeneration')
    const IsSubcontractUser = get(this.props, 'authData.user.is_subcontract_role')
    if (IsSubcontractUser) window.location = '/home'

    const confirmStatus = get(this.props, 'confirmStatus')
    const confirmType = get(this.props, 'confirmType')
    const confirmMessage = get(this.props, 'confirmMessage')

    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        { !isFetching &&
          <Searchbar
            data={ get(this.state, 'myLeaveRequests') }
            moment={ this.state.moment }
            activeTab={ this.state.activeTab }
            toggle={ this.toggle }
            onMomentChange={ this.onMomentChange }
            onRangeChange={ this.onRangeChange }
            handleLeaveRequest={ this.handleLeaveRequest }
            handleCompensateRequest={ this.handleCompensateRequest }
          />
        }
        <ModalMessage
          hide={ () => this.props.hideConfirm(confirmType) }
          show={
            confirmType === 'showPreview'
            || confirmType === 'uploadFail'
            || confirmType === 'showSuccess'
            || confirmType === 'cancelSuccess'
          }
          type={ confirmStatus }
          message={ confirmMessage }
          button={ this.selectButton(confirmStatus, confirmType) }
        />
        { this.state.confirmDiscard &&
        <DiscardRequest
          open={ this.state.confirmDiscard }
          toggle={ () => this.setState({ confirmDiscard: !this.state.confirmDiscard }) }
          clickCancelButton={ (type) => {
            if (type === 'yes') {
              const {
                showPreview,
                showRequestForm,
                showCompensateForm,
                showCompensatePreview,
              } = this.state
              if (showPreview) this.setState({ showPreview: !this.state.showPreview })
              else if (showRequestForm) {
                this.setState({ showRequestForm: !this.state.showRequestForm })
              } else if (showCompensateForm) {
                this.setState({ showCompensateForm: !this.state.showCompensateForm })
              } else if (showCompensatePreview) {
                this.setState({ showCompensatePreview: !this.state.showCompensatePreview })
              }
            }
            this.setState({ confirmDiscard: !this.state.confirmDiscard })
          } }
        />
        }
        { this.state.showRequestForm &&
        <LeaveRequestForm
          loading={ this.state.loading }
          filename={ this.state.filename }
          attachment_url={ this.state.attachment_url }
          newLeaveRequest={ this.state.newLeaveRequest }
          showRequestForm={ this.state.showRequestForm }
          leaveTypeList={ myLeaveHelper.createLeaveTypeList(leaveTypes) }
          approverList={ this.state.approverList }
          handleInputLeave={ this.handleInputLeave }
          validateLeaveRequest={ this.validateLeaveRequest }
          handleCloseRequest={ () => this.setState({ confirmDiscard: !this.state.confirmDiscard }) }
          uploadFile={ this.uploadFile }
          removeFile={ this.removeFile }
        />
        }
        { this.state.showPreview &&
        <LeaveRequestPreview
          newLeaveRequest={ this.state.newLeaveRequest }
          showPreview={ this.state.showPreview }
          meta={ this.state.meta }
          attachment_url={ this.state.attachment_url }
          filename={ this.state.filename }
          handleBack={ () => {
            this.setState({
              showRequestForm: !this.state.showRequestForm,
              showPreview: !this.state.showPreview,
            })
          } }
          clickConfirmLeave={ this.clickConfirmLeave }
          handleCloseRequest={ () => this.setState({ confirmDiscard: !this.state.confirmDiscard }) }
        />
        }
        { this.state.showCompensateForm &&
        <CompensateRequestForm
          newCompensateRequest={ this.state.newCompensateRequest }
          showCompensateForm={ this.state.showCompensateForm }
          projectList={ this.state.projectList }
          compensateApprovers={ this.state.compensateApprovers }
          handleInputCompensate={ this.handleInputCompensate }
          validateCompensateRequest={ this.validateCompensateRequest }
          handleCloseRequest={ () => this.setState({ confirmDiscard: !this.state.confirmDiscard }) }
        />
        }
        { this.state.showCompensatePreview &&
        <CompensateRequestPreview
          newCompensateRequest={ this.state.newCompensateRequest }
          createdCompensatePreview={ this.state.createdCompensatePreview }
          showCompensatePreview={ this.state.showCompensatePreview }
          handleBack={ () => {
            this.setState({
              showCompensateForm: !this.state.showCompensateForm,
              showCompensatePreview: !this.state.showCompensatePreview,
            })
          } }
          clickConfirmCompensate={ this.clickConfirmCompensate }
          handleCloseRequest={ () => this.setState({ confirmDiscard: !this.state.confirmDiscard }) }
        />
        }
        { !isFetching &&
        <TabContent activeTab={ this.state.activeTab } >
          <TabPane tabId="1">
            { this.state.activeTab === '1' &&
            <Dashboard
              prettyLeaveGeneration={ get(this, `state.prettyLeaveGeneration.${moment().year()}`, []) }
              prettyLeaveTypeWithLeaveRequest={ get(this, `state.prettyLeaveTypeWithLeaveRequest`, []) }
            />
            }
          </TabPane>
          <CalendarTab tabId="2">
            { this.state.activeTab === '2' &&
            <Calendar
              myLeaveRequests={ this.state.myLeaveRequests }
              myCompensateRequestsHistory={ this.state.myCompensateRequestsHistory }
              publicHoliday={ get(this.props, 'getPublicHolidayData') }
              moment={ this.state.moment }
              range={ this.state.range }
              teamCalendar={ false }
              myUser={ this.state.myUser }
              users={ this.state.users }
              leaveTypes={ leaveTypes }
              projects={ this.state.myCompensateRequests.prettyProjects }
              myCompensate={ this.state.myCompensateRequestsHistory }
              findFullNameByID={ (id) => myLeaveHelper.findFullNameByID(id, this.state.users) }
            />
            }
          </CalendarTab>
          <TabPane tabId="3">
            { this.state.activeTab === '3' &&
            <LeaveHistory
              myLeaveRequests={ this.state.myLeaveRequests }
              myCompensateRequestsHistory={ this.state.myCompensateRequestsHistory }
              myCompensateRequests={ this.state.myCompensateRequests }
              leaveTypes={ leaveTypes }
              users={ this.state.users }
              cancelLeaveRequest={ this.props.cancelLeaveRequest }
            />
            }
          </TabPane>
        </TabContent>
        }
      </Wrapper>
    )
  }
}

MyLeavePage.propTypes = {
  showConfirm: PropTypes.func.isRequired,
  resetAuth: PropTypes.func.isRequired,
  previewCompensateRequest: PropTypes.func.isRequired,
  cancelLeaveRequest: PropTypes.func.isRequired,
  createLeaveRequest: PropTypes.func.isRequired,
  createCompensateRequest: PropTypes.func.isRequired,
  previewLeaveRequest: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
  getAuth: PropTypes.func.isRequired,
  getLeaveType: PropTypes.func.isRequired,
  getLeaveRequest: PropTypes.func.isRequired,
  getCompensateRequest: PropTypes.func.isRequired,
  getPublicHoliday: PropTypes.func.isRequired,
  getLeaveGeneration: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  getIsFetchingLeave: leaveRequestSelector.getIsFetching,
  getIsFetchingCompensate: compensateRequestSelector.getIsFetching,
  getIsFetchingLeaveGeneration: leaveGenerationSelector.getIsFetching,
  getMyLeaveRequests: leaveRequestSelector.getMyLeaveRequests,
  getPreviewLeaveRequest: leaveRequestSelector.getMetaLeaveRequest,
  getLeaveTypeData: leaveTypeSelector.getLeaveTypeData,
  createLeaveRequestData: leaveRequestSelector.createLeaveRequestData,
  getPublicHolidayData: publicHolidaySelector.getPublicHolidayData,
  getLeaveGenerationData: leaveGenerationSelector.getLeaveGenerationData,
  cancelLeaveRequestData: leaveRequestSelector.cancelLeaveRequestData,
  authData: authSelector.getAuth,
  redirectAuth: authSelector.redirectAuth,
  redirectLeaveRequest: leaveRequestSelector.redirectLeaveRequest,
  redirectCompensateRequest: compensateRequestSelector.redirectCompensateRequest,
  getMyCompensateRequests: compensateRequestSelector.getMyCompensateRequests,
  getPreviewCompensateRequest: compensateRequestSelector.getMetaCompensateRequest,
  createCompensateRequestData: compensateRequestSelector.createCompensateRequestData,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getLeaveRequest: leaveRequestAction.getLeaveRequest,
  resetGetLeaveRequest: leaveRequestAction.resetGetLeaveRequest,
  previewLeaveRequest: leaveRequestAction.previewLeaveRequest,
  resetPreviewLeaveRequest: leaveRequestAction.resetPreviewLeaveRequest,
  createLeaveRequest: leaveRequestAction.createLeaveRequest,
  resetCreateLeaveRequest: leaveRequestAction.resetCreateLeaveRequest,
  cancelLeaveRequest: leaveRequestAction.cancelLeaveRequest,
  resetCancelLeaveRequest: leaveRequestAction.resetCancelLeaveRequest,
  getLeaveType: leaveTypeAction.getLeaveType,
  getPublicHoliday: publicHolidayAction.getPublicHoliday,
  getLeaveGeneration: leaveGenerationAction.getLeaveGeneration,
  resetGetLeavegeneration: leaveGenerationAction.resetGetLeaveGeneration,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuth,
  getCompensateRequest: compensateRequestAction.getCompensateRequest,
  resetGetCompensateRequest: compensateRequestAction.resetGetCompensateRequest,
  previewCompensateRequest: compensateRequestAction.previewCompensateRequest,
  resetPreviewCompensateRequest: compensateRequestAction.resetPreviewCompensateRequest,
  createCompensateRequest: compensateRequestAction.createCompensateRequest,
  resetCreateCompensateRequest: compensateRequestAction.resetCreateCompensateRequest,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withLayout(MyLeavePage))

const Wrapper = styled(Container)`
  @media (max-width: 575.98px) {
    padding-right:0%;
  }
  @media (max-width: 767.98px) {
    padding-right:0%;
  }
  @media (max-width: 991.98px) {
    padding-right:0%;
  }
  padding: 0px;
  background-color: #F1F1F1;
  position: relative;
  height: 100%;
`
const CalendarTab = styled(TabPane)`
  @media (max-width: 575.98px) {
    display:none;
  }
  @media (max-width: 767.98px) {
    display:none;
  }
  @media (max-width: 991.98px) {
    display:none;
  }
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/my-leave/index.js